import album from '../components/album';

export default {
  init() {
    album.init('previous');
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateArchivesAlbum.js